
function spacing(options) {
  switch (options.size) {
    case 'fon':
      return [30, 15, 0, 15];
    case 'soc':
      return [10, 10, 10, 10];
    case 'appfeed':
      return [3, 0, 3, 0];
    case 'video':
      return [120, 220, 140, 120];
    case 'twitterVideo':
      return [40, 60, 60, 60];
  }

  const left = options.type === 'scatter' ? 1 : 0;
  if (options.product === 'knewz') {
    return [10, 10, 10, 10]
  }
  return [0, 0, 0, 0];
}

export default spacing;



// WEBPACK FOOTER //
// ./src/chart/outer/spacing.js